import { render } from "./ContentList.vue?vue&type=template&id=1bdf683a"
import script from "./ContentList.vue?vue&type=script&lang=js"
export * from "./ContentList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__